import { EnderecoAdministrativoDTO } from './EnderecoAdministrativoDTO';

export class ClienteAdministrativoDTO {
    id?: number;
    nome?: string;
    cpfCnpj?: string;
    frota?: boolean;
    email?: string;
    telefone?: string;
    endereco?: EnderecoAdministrativoDTO
    constructor(
      id?: number,
      nome?: string,
      cpfCnpj?: string,
      frota?: boolean,
      email?: string,
      telefone?: string,
      endereco?: EnderecoAdministrativoDTO
    ) {
     this.id = id,
     this.nome = nome,
     this.cpfCnpj = cpfCnpj,
     this.frota = frota,
     this.email = email,
     this.telefone = telefone,
     this.endereco = endereco
    }
  }